import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {useSnackbar} from 'notistack';
import React from 'react';

const InnerSnackbarUtilsConfigurator = (props) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef;
const setUseSnackbarRef = (useSnackbarRefProp) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  );
};

const SnackbarUtil = {
  success(msg, options) {
    this.toast(msg, 'success', options);
  },
  warning(msg, options) {
    this.toast(msg, 'warning', options);
  },
  info(msg, options) {
    this.toast(msg, 'info', options);
  },
  error(msg, options) {
    this.toast(msg, 'error', options);
  },
  toast: (msg, variant = 'default', options) => {
    useSnackbarRef.enqueueSnackbar(msg, {
      action: (key) => (
        <IconButton
          onClick={() => useSnackbarRef.closeSnackbar(key)}
          color="inherit"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      ),
      ...(options || {}),
      variant,
    });
  },
};

export default SnackbarUtil;
